import { Box, Typography } from "@mui/material";
import { PageHeader } from "@components/ui_v2";

/**
 * Pantalla de oferta genérica para productos sin pantalla propia todavía.
 * Se usa como fallback en el dispatcher de `oferta/index.tsx`.
 */
export const OfertaDefault = () => (
  <Box>
    <PageHeader eyebrow="Resultado · Oferta" title="Tu solicitud está en proceso" />
    <Typography sx={{ fontSize: 14, color: "tokens.textTertiary", textAlign: "center", mt: 4 }}>
      Esta pantalla aún no está disponible para tu tipo de producto. Un ejecutivo se pondrá en contacto contigo.
    </Typography>
  </Box>
);
